import { createRouter, createWebHistory } from 'vue-router';
import HomePage from '../views/HomePage.vue';
import AboutUs from '../views/AboutUs.vue';
import OurPrograms from '../views/OurPrograms.vue';
import PhotoGallery from '../views/PhotoGallery.vue';
import DonateUs from '../views/DonateUs.vue';
import ContactUs from '../views/ContactUs.vue';
import NewsEvents from '../views/NewsEvents.vue'; // New

const routes = [
  { path: '/', name: 'Home', component: HomePage },
  { path: '/about', name: 'About', component: AboutUs },
  { path: '/programs', name: 'Programs', component: OurPrograms },
  { path: '/gallery', name: 'Gallery', component: PhotoGallery },
  { path: '/news', name: 'NewsEvents', component: NewsEvents }, // New
  { path: '/donate', name: 'Donate', component: DonateUs },
  { path: '/contact', name: 'Contact', component: ContactUs },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

export default router;